module.exports = __webpack_public_path__ + "static/img/aboutUs05.9fa5471.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs05.jpg
// module id = 1357
// module chunks = 1